// extracted by mini-css-extract-plugin
export var button = "_5h-0";
export var icon = "_5h-1";